/**
 *   Copyright (C) Cylergie - All Rights Reserved
 * Proprietary and confidential
 * Subject to French law on copyright
 * Unauthorized copying of this file, via any medium is strictly prohibited: https://crigen.myengie.com/copyright
 * Any request for authorization of use should be addressed by email to“mvalo.bvt@engie.com” with the subject “Copyright Statement in Source Code”
 * Written in 2024
 */

export default {
  setAuthenticated({ commit }, authenticated) {
    commit('SET_AUTHENTICATED', authenticated);
  },
};
